export default __webpack_public_path__ + "static/media/art-blk-banner-2.6a79bb30.jpg";